import { useMutation } from "@apollo/client/react"; import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Grid, Typography } from "@mui/material";
import CardBox from "../../CardBox/CardBox";
import { RenderInputByTypeMobile } from "../../../../../../components/formGroupGenerator/RenderInputByTypeMobile";
import { useVisita } from "../../../../../../context/VisitaContext";
import SAVE_INSUMO_CAPACITACION_AE, { adaptAddVisitaInsumoCapacitacionInput } from "../../../../../../data/graphQL/mutations/Visitas/saveVisitaInsumoCapacitacionAE";
import SAVE_INSUMO_CAPACITACION_AP, { adaptAddVisitaInsumoCapacitacionAPInput } from "../../../../../../data/graphQL/mutations/Visitas/saveVisitaInsumoCapacitacionAP";

import { useStepSave } from "../../../../hooks/useStepSave";
import { validateStepFields } from "../../../../utils/visitaStepValidation";

export default function InsumosYCapacitaciones({ esUrgencia, readOnly, onSaveRef, onExposeFormatted, esProgramaAP }) {
  const [formData, setFormData] = useState({});

  const { visita, setVisita } = useVisita();

  const [saveAE] = useMutation(SAVE_INSUMO_CAPACITACION_AE);
  const [saveAP] = useMutation(SAVE_INSUMO_CAPACITACION_AP);

  const formattedGroups = useMemo(() => {
    return groups.map((group) => {
      const formattedInputs = group.inputs.map((input) => {
        const newInput = { ...input };

        switch (input.name) {
          default:
            break;
        }

        if (esUrgencia) newInput.required = false;

        if (readOnly) newInput.disabled = true;

        return newInput;
      });

      return {
        ...group,
        inputs: formattedInputs
      };
    });
  }, [readOnly, esUrgencia, formData]);

  useStepSave(onSaveRef, async (validate) => {
    if (validate) validateStepFields({ formattedGroups, formData });

    const save = esProgramaAP ? saveAP : saveAE;
    const adapter = esProgramaAP ? adaptAddVisitaInsumoCapacitacionAPInput : adaptAddVisitaInsumoCapacitacionInput;
    const { data } = await save({ variables: { ...adapter(formData) } });

    const idInsumoCapacitacion = data?.[esProgramaAP ? 'saveVisitaInsumoCapacitacionAP' : 'saveVisitaInsumoCapacitacionAE']?.idInsumoCapacitacion;
    if (!idInsumoCapacitacion) throw new Error("Error al guardar");

    setVisita((prev) => ({
      ...prev,
      ...formData,
      idInsumoCapacitacion: idInsumoCapacitacion
    }));

  });

  const handleChange = useCallback((name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  }, []);

  useEffect(() => {
    setFormData(visita);
  }, [visita]);

  useEffect(() => {
    onExposeFormatted?.({
      stepId: esProgramaAP ? 'insumosYCapacitacionesAP' : 'insumosYCapacitaciones',
      stepName: 'Insumos y capacitaciones',
      formattedGroups
    });
  }, [onExposeFormatted, formattedGroups]);

  return (
    <>
      {formattedGroups.map((group, gIdx) =>
        <CardBox key={gIdx}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: "bold", mb: 1 }}>

            {group.title}
          </Typography>
          <Grid container spacing={2}>
            {group.inputs.map((input) =>
              <Grid size={{ xs: 12 }} key={input.name}>
                <RenderInputByTypeMobile
                  input={input}
                  value={formData[input.name]}
                  handleChange={handleChange} />

              </Grid>
            )}
          </Grid>
        </CardBox>
      )}
    </>);

}

const groups = [
  {
    title: "Control de insumos en domicilio",
    inputs: [
      {
        name: "insumoVencido",
        displayName: "¿Tiene algún insumo que esté vencido?",
        type: "long_string",
        maxLength: 250,
        required: true
      },
      {
        name: "cantidadSuficiente",
        displayName: "¿Tiene las cantidades suficientes?",
        type: "long_string",
        maxLength: 250,
        required: true
      },
      {
        name: "reclamoCantidadCalidad",
        displayName: "¿Tiene algún reclamo de cantidad o calidad?",
        type: "long_string",
        maxLength: 250,
        required: true
      }]

  },
  {
    title: "Capacitaciones",
    inputs: [
      {
        name: "observacionCapacitacion",
        displayName: "Observación",
        type: "long_string",
        maxLength: 250,
        required: true
      }]

  }];